module.exports = __webpack_public_path__ + "static/media/lost-poster.5c27d233.jpg";